import { Container, Text } from '@chakra-ui/react';
import { getTranslations } from 'next-intl/server';

import { ForgotPasswordContainer } from '@/modules/authentication/presentation/containers';

export const ForgotPasswordScreen = async () => {
	const t = await getTranslations('authentication.forgotPassword');

	return (
		<Container display="grid" gap="md" maxW="xl">
			<Text textAlign="center" textStyle="h1">
				{t('title')}
			</Text>
			<ForgotPasswordContainer />
		</Container>
	);
};
